import { Flex, Text, Icon, Skeleton } from "components/common"
import theme from "utils/themeVars"
import { t } from "i18next"

const THEME_COLORS = {
  "Sales Pitch": theme["accent-color"],
  "Meeting Invite": "#33a8c7",
  "Event Discussion": "#66bfd6",
  "Financial Discussion": "#99d6e4",
  "General Engagement": "#aadee8",
}

const SummaryProgressBar = ({ data = [], loading = false }) => {
  if (loading) {
    return <Skeleton active paragraph={{ rows: 2 }} />
  }

  if (!data || data.length === 0) {
    return (
      <Text type="secondary" className="fs14">
        {t("No themes data available")}
      </Text>
    )
  }
  const dataWithColors = data?.map((item, index) => ({
    ...item,
    color: THEME_COLORS?.[item?.label],
  }))

  return (
    <div style={{ width: "100%" }}>
      <div
        style={{
          display: "flex",
          height: 18,
          borderRadius: 2,
          overflow: "hidden",
          backgroundColor: "#e0e0e0",
        }}
      >
        {dataWithColors?.map((item, index) => (
          <div
            key={index}
            style={{
              width: `${item?.percent}%`,
              backgroundColor: item?.color,
              transition: "width 0.5s ease",
            }}
          />
        ))}
      </div>

      <Flex justify="flex-start" gap="16px" wrap="wrap" style={{ marginTop: 8 }}>
        {dataWithColors?.map((item, index) => (
          <Flex key={index} gap="4px" align="center">
            <Icon icon="BsDot" size={25} style={{ color: item?.color }} />
            <Text italic className="fs14 gray-800">
              {item?.label} ({item?.percent}%)
            </Text>
          </Flex>
        ))}
      </Flex>
    </div>
  )
}

export default SummaryProgressBar
